import { HelpLink } from 'elements/link/HelpLink'
import { ComponentVersionsInherit, ComponentVersions_3_0, Typography } from 'opensolar-ui'
import { useTranslate } from 'react-admin'

const ActionTitle = ({ record, style }) => {
  const translate = useTranslate()
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Typography variant="body2" style={style}>
        {translate('Project Actions')}: {record ? `"${record.title}"` : ''}
      </Typography>
    </ComponentVersionsInherit>
  )
}

const Subtitle = () => {
  const translate = useTranslate()
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Typography variant="body2">
        {translate("Customise your team's workflow to match your business' needs.")}{' '}
        <HelpLink href="https://support.opensolar.com/hc/en-us/articles/13277670208271-How-to-customize-project-workflows-stages-and-actions" />
      </Typography>
    </ComponentVersionsInherit>
  )
}

export default {
  list: { lazy: () => import('./Actions'), component: 'ActionList' },
  show: { lazy: () => import('./Actions'), component: 'ActionShow' },
  edit: { lazy: () => import('./Actions'), component: 'ActionEdit' },
  create: { lazy: () => import('./Actions'), component: 'ActionCreate' },

  options: {
    create: {
      title: 'Create Action',
      subtitle: null,
      breadCrumb: 'Create Action',
    },
    list: {
      title: 'Project Actions',
      subtitle: <Subtitle />,
      breadCrumb: 'Actions',
    },
    edit: {
      title: <ActionTitle />,
      subtitle: null,
      breadCrumb: 'Edit Action',
    },
  },
}
